// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/PlayfairDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/alfont_com_GE-Dinar-One-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/SF-Arabic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'TitleFonts';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'ParagraphFonts';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RTLTitleFonts';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'RTLParagraphFonts';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

body {
    background-color: #eee8f5;
    margin: 0;
    color: #3f3f40;
    font-family: "ParagraphFonts", serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media (max-width: 991px) {

    html,
    body {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden;
    }

    main {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
    }
}

/* For left-to-right text */
body:dir(ltr) {
    font-family: "ParagraphFonts", serif;
}

/* For right-to-left text */
body:dir(rtl) {
    font-family: "RTLParagraphFonts", serif;
}

/* Title fonts for left-to-right text */
body:dir(ltr) h1,
body:dir(ltr) h2,
body:dir(ltr) h3,
body:dir(ltr) h4,
body:dir(ltr) h5,
body:dir(ltr) h6 {
    font-family: "TitleFonts", serif;
}

/* Title fonts for right-to-left text */
body:dir(rtl) h1,
body:dir(rtl) h2,
body:dir(rtl) h3,
body:dir(rtl) h4,
body:dir(rtl) h5,
body:dir(rtl) h6 {
    font-family: "RTLTitleFonts", serif;
}

.mirrored-image::before {
    content: '';
    position: absolute;
    inset: 0;
    transform: scaleX(-1);
    z-index: -1;
}


.pop-over{
    border-radius: 4px!important;
}
@media(max-width: 767px) {

    .css-qq8w9n-MuiGrid-root,
    .css-1sk9o47-MuiContainer-root,.css-1uyohl9 {
        /* padding: 0 !important; */
    }
    .css-qq8w9n-MuiGrid-root>.MuiGrid-item{
        /* order: 2; */
    }
    .css-zc8q3n-MuiTypography-root{

    }
    .css-1bti41h::before,.css-jk7u3i::before{
        background-size: cover !important;
        background-position: left !important;
    }
    .css-f1k78n-MuiStack-root{
        top: 100px;
    }
    .css-17t18k6-MuiContainer-root{
        /* padding-bottom: 60px!important; */
    }
    .css-v39pk0-MuiStack-root{

    }
  
    .css-1ldf9ke-MuiGrid-root{
        /* padding-top: 60px; */
    }
    .css-1g1tkon {
        width: 100%!important;
        transform: scale(2);
        margin-top: -50px!important;
    }
    .css-rdde6b {
        width: 100%!important;
        transform: scale(1.5);
        margin-top: -50px!important;
    }
    .css-udifax,.css-zk6mke{
        width: 105%!important;
        left: 0!important;
    }
    .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-md-6.css-1iggn1w-MuiGrid-root .css-1q0o83k{
        /* display: none; */
    }
    .css-27h6s{
        /* background-color: #EEE8F5!important; */
    }
    .css-hlmx3t{
        /* background-color: transparent!important;
        padding-top: 0px!important;
        padding-bottom: 0px!important; */

    }
    .css-12jutib{
        padding-bottom: 24px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,+DAAwE;IACxE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+DAA8D;IAC9D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,+DAA8E;IAC9E,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+DAA2D;IAC3D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,cAAc;IACd,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;;IAEI;;QAEI,oBAAoB;QACpB,qBAAqB;QACrB,sBAAsB;QACtB,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,sBAAsB;QACtB,0BAA0B;IAC9B;AACJ;;AAEA,2BAA2B;AAC3B;IACI,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI,uCAAuC;AAC3C;;AAEA,uCAAuC;AACvC;;;;;;IAMI,gCAAgC;AACpC;;AAEA,uCAAuC;AACvC;;;;;;IAMI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,WAAW;AACf;;;AAGA;IACI,4BAA4B;AAChC;AACA;;IAEI;;QAEI,2BAA2B;IAC/B;IACA;QACI,cAAc;IAClB;IACA;;IAEA;IACA;QACI,iCAAiC;QACjC,oCAAoC;IACxC;IACA;QACI,UAAU;IACd;IACA;QACI,oCAAoC;IACxC;IACA;;IAEA;;IAEA;QACI,uBAAuB;IAC3B;IACA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,2BAA2B;IAC/B;IACA;QACI,qBAAqB;QACrB,qBAAqB;QACrB,2BAA2B;IAC/B;IACA;QACI,qBAAqB;QACrB,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,yCAAyC;IAC7C;IACA;QACI;;wCAEgC;;IAEpC;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["@font-face {\n    font-family: 'TitleFonts';\n    src: url('./assets/fonts/PlayfairDisplay-Medium.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'ParagraphFonts';\n    src: url('./assets/fonts/Lato-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RTLTitleFonts';\n    src: url('./assets/fonts/alfont_com_GE-Dinar-One-Bold.otf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'RTLParagraphFonts';\n    src: url('./assets/fonts/SF-Arabic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\nbody {\n    background-color: #eee8f5;\n    margin: 0;\n    color: #3f3f40;\n    font-family: \"ParagraphFonts\", serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n@media (max-width: 991px) {\n\n    html,\n    body {\n        margin: 0 !important;\n        padding: 0 !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        overflow-x: hidden;\n    }\n\n    main {\n        margin: 0 !important;\n        padding: 0 !important;\n        width: 100% !important;\n        max-width: 100% !important;\n    }\n}\n\n/* For left-to-right text */\nbody:dir(ltr) {\n    font-family: \"ParagraphFonts\", serif;\n}\n\n/* For right-to-left text */\nbody:dir(rtl) {\n    font-family: \"RTLParagraphFonts\", serif;\n}\n\n/* Title fonts for left-to-right text */\nbody:dir(ltr) h1,\nbody:dir(ltr) h2,\nbody:dir(ltr) h3,\nbody:dir(ltr) h4,\nbody:dir(ltr) h5,\nbody:dir(ltr) h6 {\n    font-family: \"TitleFonts\", serif;\n}\n\n/* Title fonts for right-to-left text */\nbody:dir(rtl) h1,\nbody:dir(rtl) h2,\nbody:dir(rtl) h3,\nbody:dir(rtl) h4,\nbody:dir(rtl) h5,\nbody:dir(rtl) h6 {\n    font-family: \"RTLTitleFonts\", serif;\n}\n\n.mirrored-image::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    transform: scaleX(-1);\n    z-index: -1;\n}\n\n\n.pop-over{\n    border-radius: 4px!important;\n}\n@media(max-width: 767px) {\n\n    .css-qq8w9n-MuiGrid-root,\n    .css-1sk9o47-MuiContainer-root,.css-1uyohl9 {\n        /* padding: 0 !important; */\n    }\n    .css-qq8w9n-MuiGrid-root>.MuiGrid-item{\n        /* order: 2; */\n    }\n    .css-zc8q3n-MuiTypography-root{\n\n    }\n    .css-1bti41h::before,.css-jk7u3i::before{\n        background-size: cover !important;\n        background-position: left !important;\n    }\n    .css-f1k78n-MuiStack-root{\n        top: 100px;\n    }\n    .css-17t18k6-MuiContainer-root{\n        /* padding-bottom: 60px!important; */\n    }\n    .css-v39pk0-MuiStack-root{\n\n    }\n  \n    .css-1ldf9ke-MuiGrid-root{\n        /* padding-top: 60px; */\n    }\n    .css-1g1tkon {\n        width: 100%!important;\n        transform: scale(2);\n        margin-top: -50px!important;\n    }\n    .css-rdde6b {\n        width: 100%!important;\n        transform: scale(1.5);\n        margin-top: -50px!important;\n    }\n    .css-udifax,.css-zk6mke{\n        width: 105%!important;\n        left: 0!important;\n    }\n    .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-md-6.css-1iggn1w-MuiGrid-root .css-1q0o83k{\n        /* display: none; */\n    }\n    .css-27h6s{\n        /* background-color: #EEE8F5!important; */\n    }\n    .css-hlmx3t{\n        /* background-color: transparent!important;\n        padding-top: 0px!important;\n        padding-bottom: 0px!important; */\n\n    }\n    .css-12jutib{\n        padding-bottom: 24px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
